<div class="links" [class.mini-infocard]="miniInfocard()">
    @for (prospect of prospects(); track $index) {
        <div class="link-item fact-sheet" (click)="openPdfProspect(prospect)">
            @if (prospect.isLoading) {
                <div class="loader-wrapper">
                    <ev-logo-loader variant="dots" width="25px" />
                </div>
            } @else {
                Prospekt
            }
        </div>
    }

    @for (priceItem of priceList(); track $index) {
        <div class="link-item fact-sheet" (click)="openPdfProspect(priceItem)">Prislisten</div>
    }

    @for (publicationType of projectPublicationsList(); track $index) {
        <div [title]="publicationType.publicationUrl" class="link-item" (click)="openProspect(publicationType.publicationUrl)">
            @if (publicationType.displayText === "hjem.no") {
                <span class="publication-icon hjem"></span>
                <div>Hjem-annonse</div>
            } @else if (publicationType.displayText === "finn.no") {
                <span class="publication-icon finn"></span>
                <a [href]="finnUrl()" target="_blank">Finn-annonse</a>
            } @else {
                <div class="first-upper">{{ publicationType.groupText }}</div>
            }
            <span class="external-link"></span>
        </div>
    }
    @if (miniInfocard()) {
        <a class="link-item" [href]="infopageUrl()" target="_blank"
            >{{ stageMode() ? "Gå til trinn" : "Gå til prosjektoversikt" }} <span class="external-link"></span
        ></a>
    } @else if (mapLatLon() != null) {
        <a class="link-item ev-kart" [href]="evKartLink()" target="_blank"> Vis i evKart </a>
    }
</div>
